export default __webpack_public_path__ + "d7baf01ecc81615e54fd6c0b7210907c.png";